import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class ServeisTerritorials {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/serveisTerritorials/`;
  private serveisTerritorials: any[] = [];

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService
  ) { }

  init(): ng.IPromise<any[]> {
    return this.$http.get(`${this.apiurl}findAll?`)
      .then((response: any) => {
        this.serveisTerritorials = response.data.serveisTerritorials || [];

        // Remove the last item and sort
        this.serveisTerritorials.pop();
        this.serveisTerritorials = this.serveisTerritorials.sort((a, b) => {
          return a.nomServeiTerritorial > b.nomServeiTerritorial ? 1 : -1;
        });

        return this.serveisTerritorials;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }
}

angularJsApp.service(AppServicesEnum.SERVEIS_TERRITORIALS_SERVICE, ServeisTerritorials);
